import { load } from "recaptcha-v3"

/**
 * reCAPTCHA is only needed when a booking is paid for or changed, but Google's script is about
 * 350 KB and takes a phone 0.5-1 s to run. So it only downloads when something asks for a token,
 * or straight away on the pages that will (app.js calls startLoadingRecaptcha). Same API as
 * vue-recaptcha-v3: this.$recaptchaLoaded() and this.$recaptcha(action), or useReCaptcha()
 */
let loading = null

// Google's loader waits forever if its script loads but never gets ready (for example when a blocker
// stubs it or gstatic.com is blocked), which would leave the pay button spinning. So give up after a
// while: the booking code then carries on without a token, as it already does when reCAPTCHA fails
const TIME_LIMIT_MS = 10000

const withinTimeLimit = (promise) => new Promise((resolve, reject) => {
  const timer = setTimeout(() => reject(new Error("reCAPTCHA took too long")), TIME_LIMIT_MS)
  promise.then(resolve, reject).finally(() => clearTimeout(timer))
})

const loadRecaptcha = () => {
  if (!loading) {
    loading = load(window.recaptchaSiteKey, { autoHideBadge: true }).catch((error) => {
      // Let the next call try again (the booking code retries once after a failure)
      loading = null
      throw error
    })
  }

  return loading
}

export const recaptchaLoaded = () => withinTimeLimit(loadRecaptcha()).then(() => true)

export const executeRecaptcha = (action) => withinTimeLimit(loadRecaptcha().then((recaptcha) => recaptcha.execute(action)))

export const useReCaptcha = () => ({ executeRecaptcha, recaptchaLoaded })

export const startLoadingRecaptcha = () => {
  loadRecaptcha().catch(() => {})
}

export const RecaptchaPlugin = {
  install(app) {
    app.config.globalProperties.$recaptchaLoaded = recaptchaLoaded
    app.config.globalProperties.$recaptcha = executeRecaptcha
  },
}
